export const SENTRY_TRACES_SAMPLE_RATE = 0.05;

export const SENTRY_IGNORE_ERRORS = [
  `Failed to execute 'evaluate' on 'Document': The string '' is not a valid XPath expression.`,
  'timeout of 15000ms exceeded',
  'Network Error',
  'Request aborted',
  'Request failed with status code 502',
  'Request failed with status code 400',
  'Request failed with status code 500',
  'Object captured as exception with keys:',
];
